<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jbcgSJ/tc-custom/9780374719388.jpg?1719374546838" alt="This image is the cover for the book Thin Places"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thin Places
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A <i>Los Angeles Times </i>Bestseller</b><br/><b><br/>A <i>Lit Hub</i> | <i>Chicago Review</i> | <i>Ms. </i>Magazine March pick </b><br/><b>A Lambda Literary Most Anticipated Book<br/><br/>In this perceptive and provocative essay collection, an award-winning writer shares her personal and reportorial investigation into America’s search for meaning<br/><br/></b>When Jordan Kisner was a child, she was saved by Jesus Christ at summer camp, much to the confusion of her nonreligious family. She was, she writes, “just naturally reverent,” a fact that didn’t change when she—much to her own confusion—lost her faith as a teenager. Not sure why her religious conviction had come or where it had gone, she did what anyone would do: “You go about the great American work of assigning yourself to other gods: yoga, talk radio, neoatheism, CrossFit, cleanses, football, the academy, the American Dream, Beyoncé.” <br/><br/>A curiosity about the subtle systems guiding contemporary life pervades Kisner’s work. Her celebrated essay “Thin Places” (<i>Best American Essays</i> 2016), about an experimental neurosurgery developed to treat severe obsessive-compulsive disorder, asks how putting the neural touchpoint of the soul on a pacemaker may collide science and psychology with philosophical questions about illness, the limits of the self, and spiritual transformation. How should she understand the appearance of her own obsessive compulsive disorder at the very age she lost her faith? <br/><br/>Intellectually curious and emotionally engaging, the essays in <i>Thin Places</i> manage to be both intimate and expansive, illuminating an unusual facet of American life, as well as how it reverberates with the author’s past and present preoccupations.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jordan Kisner
      </h2>
      
      <p class="authorDescription body article"><B>Jordan Kisner</B>'s writing has appeared in <I>n+1</I>, <I>The</I><I>New York Times Magazine</I>,<I> The Atlantic</I>,<I> GQ</I>,<I> The Guardian, The American Scholar</I>, <I>California Sunday</I>,<I> The New Yorker</I>, <I>The New Republic</I>, <I>New York </I>magazine, <I>Pop-Up Magazine,</I> and <I>Pitchfork</I>, among other publications. Her work has received a Pushcart Prize and was selected for <I>The</I><I>Best American Essays 2016. </I>The author of<I> Thin Places: Essays from In Between</I>, she teaches creative writing at Columbia University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01fc3bd8